import { FC } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Snackbar, learningPanelNotificationVariants } from 'learning-panel-components';
import { translate } from 'translations';
import {
    selectVariant,
    selectMessage,
    selectIsOpen,
    selectIsInIframe,
    selectIsAdmin,
    onClose,
    selectTitle
} from '../redux/slices/informationSlice';

const SnackbarContainer: FC = () => {
    const dispatch = useDispatch();
    const variant = useSelector(selectVariant);
    const isAdmin = useSelector(selectIsAdmin);
    const message = useSelector(selectMessage);
    const title = useSelector(selectTitle);
    const isOpen = useSelector(selectIsOpen);
    const isInIframe = useSelector(selectIsInIframe);

    return (
        <Snackbar
            variant={isAdmin ? 'adminPanelNotification' : 'learningPanelNotification'}
            subVariant={variant as learningPanelNotificationVariants}
            message={translate(message)}
            title={translate(title as string)}
            isOpen={isOpen}
            onClose={() => {
                dispatch(onClose(null));
            }}
            isInIframe={isInIframe}
        />
    );
};

export default SnackbarContainer;
